<template>
    <div class="container my-5">
		<!-- about our company -->
		<div v-if="about.find(c => c.key === 'about' && c.id === 1)?.value">
			<div class="d-flex align-items-center">
				<i class="fas fa-building"></i>
				<h4 class="text-start mb-2 mx-2 bold">{{ $t('about-our-company') }}</h4>
			</div>
			<p class="mb-5" v-if="about.length > 0" v-html="about.find(c => c.key === 'about' && c.id === 1)?.value"></p>
		</div>

		<!-- our-mission -->
		<div v-if="about.find(c => c.key === 'mission' && c.id === 3)?.value">
			<div class="d-flex align-items-center">
				<i class="fas fa-rocket"></i>
				<h4 class="text-start mb-2 mx-2 bold">{{ $t('our-mission') }}</h4>
			</div>
			<p class="mb-5" v-if="about.length > 0" v-html="about.find(c => c.key === 'mission' && c.id === 3)?.value"></p>
		</div>

		<!-- our-vision -->
		<div v-if="about.find(c => c.key === 'vision' && c.id === 5)?.value">
			<div class="d-flex align-items-center">
				<i class="fas fa-eye"></i>
				<h4 class="text-start mb-2 mx-2 bold">{{ $t('our-vision') }}</h4>
			</div>
			<p class="mb-5" v-if="about.length > 0" v-html="about.find(c => c.key === 'vision' && c.id === 5)?.value"></p>
		</div>

		<!-- our values -->
		<div v-if="companyValues.length > 0">
			<div class="d-flex align-items-center mb-2">
				<i class="fas fa-gem"></i>
				<h4 class="text-start mb-2 mx-2 bold">{{ $t('our-values') }}</h4>
			</div>
			<div
				v-for="item in companyValues"
				:key="item.id"
				class="mb-5"
			>
				<div class="d-flex mb-2">
					<img :src="item?.primaryImage?.url" alt="" width="30">
					<h5 class="mx-3">{{ item?.title }}</h5>
				</div>
				<p v-html="item?.content"></p>
			</div>
		</div>
	</div>
</template>

<script>

import { mapState } from 'vuex'

export default {
	name: 'about-us',
	data () {
		return {}
	},

	computed: {
		...mapState({
			about: state => state.about.about,
			companyValues: state => state.companyValues.companyValues,
		})
	},

	created () {
		this.$emit('loading', true)
		const promises = [];

		if (this.about.length === 0) {
			promises.push(this.$store.dispatch('about/fetchAbout'));
		}
		if (this.companyValues.length === 0) {
			promises.push(this.$store.dispatch('companyValues/fetchCompanyValues'));
		}

		Promise.all(promises).then(() => {
			this.$emit('loading', false)
		});
	}
}
</script>

<style lang="scss" scoped>
h5 {
	margin-bottom: 0;
}
</style>